import React from 'react';
import Aux from '../../hoc/Aux';

const accordeon = (props) => {



  return (
  <Aux>
    <div className="card" style={{width: "100%"}}>
      <div className="card-header" id="headingOne" onClick={ () => props.onClick()(props.tabId) } style={{backgroundColor: "#fedd66", color: "black", padding: "0"}}>
          <button className={(props.checkOpen(props.tabId))? "btn btn-link btn-block text-left" : "btn btn-link btn-block text-left collapsed"}   type="button" style={{color: "black", fontWeight: "500", float: "left", width: "auto"}}>
            {props.headline}
          </button>
          <i className="material-icons" style={{padding: "7px", float: "right"}}>{(props.checkOpen(props.tabId))? "keyboard_arrow_up" : "keyboard_arrow_down"}</i>
      </div>
      <div id="collapseOne" className={(props.checkOpen(props.tabId))? "collapse show" : "collapse"}>
        <div className="card-body">{props.content}</div>
      </div>
    </div>
  </Aux>
  )

};

export default accordeon;



// WEBPACK FOOTER //
// ./src/components/Home/Accordeon.js